module.exports = __webpack_public_path__ + "img/page_info_place.722bfcd.svg";